define([], function () {
  var init = function(element, options){
    options = options || {};
    var maxHeight = parseInt(element.attr('data-maxHeight') || options.maxHeight || 100);
    var correctHeight = parseInt(element.attr('data-correctHeight') || options.correctHeight || 6);

    var cloned = element.find(".more-block").clone().css({
      height: 'auto',
      width: element.width(),
      maxHeight: 'none',
      overflow: 'hidden'
    }).insertAfter(element.find(".more-block"));
    var count_p = 0;
    var h = 0;

    cloned.find('p').each(function(){
      h += $(this).height() + parseFloat($(this).css("margin-bottom"), 10);
      count_p += 1;

      if(h >= maxHeight){
        return;
      }
    });

    h = (h == 0) ? maxHeight : h;

    var contentHeight = cloned.height();
    cloned.remove();

    if(contentHeight > (maxHeight + 30)){
      if(count_p > 1){
        if(isEven(count_p)){
          maxHeight += correctHeight;
        }
      }
      element.addClass('shorten-init');
      element.find('.more-block').css('height', maxHeight).css('overflow', 'hidden');
      element.append($('<a class="shorten-link">Read More<i class="fa fa-angle-right"></i></a><div class="clearfix"></div>'));

      element.on('click', '.shorten-link', function(){
        if($(this).hasClass('showed')){
          $(this).parents('div:first').find(".more-block").css('height', maxHeight);
          $(this).removeClass('showed');
        } else {
          $(this).parents('div:first').find(".more-block").css({ height: 'auto', 'max-height': 'none' });
          $(this).addClass('showed');
        }
      });
    }
  };

  var isEven = function isEven(value) {
    if (value%2 == 0)
      return true;
    else
      return false;
  };

  var show = function (content) {
    content.find('.short-content').hide();
    content.find('.all-content').show();
  };

  var hide = function(content){
    content.find('.all-content').hide();
    content.find('.short-content').show();
  };

  return {
    init: init,
    show: show,
    hide: hide
  };
});
